/**
 * PageError — the shared fail-forward error bar for the usePage-driven surfaces. A transient load failure
 * must never be a dead end: this renders the sanitized problem title (never a stack/SQL/PHI) plus a
 * "Try again" action wired to the page's retry() so the user can recover in place, without a full-page
 * reload. Reused across the non-admin usePage pages so the recovery affordance reads identically everywhere.
 */
import { SkyButton, SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { COPY } from "../lib/copy";

export function PageError({
  title,
  message,
  onRetry,
}: {
  title: string;
  /** Optional sanitized detail (problem title). Defaults to the reassuring generic load copy. */
  message?: string;
  onRetry: () => void;
}) {
  return (
    <SkyMessageBar
      intent="error"
      title={title}
      message={message ?? COPY.loadError}
      actions={
        <SkyButton appearance="secondary" size="small" onClick={onRetry}>
          Try again
        </SkyButton>
      }
    />
  );
}
